function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_ionic-ios-information-circle-outline",
  "data-name": "Icon ionic-ios-information-circle-outline",
  transform: "translate(-3.375 -3.375)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_924",
  "data-name": "Trazado 924",
  d: "M16.552,24.176A13.55,13.55,0,0,1,30.425,10.709c7.715,0,14.008,5.752,14.008,13.467S38.139,37.71,30.425,37.71A13.606,13.606,0,0,1,16.552,24.176ZM17.5,48.335H43.35v97.517H17.5Z",
  transform: "translate(113.643 63.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_925",
  "data-name": "Trazado 925",
  d: "M144.135,22.324a121.832,121.832,0,0,1,86.148,207.96,121.832,121.832,0,0,1-172.3-172.3,121.006,121.006,0,0,1,86.148-35.664m0-18.949A140.76,140.76,0,1,0,284.9,144.135,140.739,140.739,0,0,0,144.135,3.375Z"
}));

var SvgExclamationMark = function SvgExclamationMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 281.521 281.521",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExclamationMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exclamation_mark.6c6f079f.svg";
export { ForwardRef as ReactComponent };